const SHORT_FORM_PATTERN = /^\d+(s|m|h|d|w|mo|y)$/i

const UNIT_TO_SUFFIX: readonly (readonly [RegExp, string])[] = [
  [/^second$/i, 's'],
  [/^minute$/i, 'm'],
  [/^hour$/i, 'h'],
  [/^day$/i, 'd'],
  [/^week$/i, 'w'],
  [/^month$/i, 'mo'],
  [/^year$/i, 'y'],
]

const LONG_FORM_PATTERN = /^(\d+)\s+([a-z]+?)s?\s+ago$/i

export const toShortRelativeTime = (value: string): string => {
  const trimmed = value.trim()

  if (trimmed.length === 0) return value
  if (/^just\s+now$/i.test(trimmed)) return 'now'
  if (SHORT_FORM_PATTERN.test(trimmed)) return trimmed

  const match = LONG_FORM_PATTERN.exec(trimmed)
  if (!match) return value

  const [, amount, unit] = match
  const suffix = UNIT_TO_SUFFIX.find(([pattern]): boolean =>
    pattern.test(unit),
  )?.[1]

  return suffix ? `${amount}${suffix}` : value
}
